import PayrollPeriod from "../components/PayrollPeriod";
import usePayrollPeriod from "../hook/usePayrollPeriod";

const PayrollPeriodPage = () => {
    const usePayrollPeriodProps = usePayrollPeriod();
    return <PayrollPeriod {...usePayrollPeriodProps} />;
};

export default PayrollPeriodPage;
